import { render, staticRenderFns } from "./DynamicGroups.vue?vue&type=template&id=95391214&"
import script from "./DynamicGroups.vue?vue&type=script&lang=ts&"
export * from "./DynamicGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports